import React, { useState, useEffect } from "react";

import Header from "../../components/Header.jsx";
import Footer from "../../components/Footer.jsx";
import Loader from "../../components/Loader.jsx";
import ErrorPage from "../ErrorPage.jsx";
import "../../styles/pages/subpages/social-activities_page.css";

import ChevronRightIcon from "../../assets/icons/chevron-right.svg";
import SocialActivitiesPageImage from "../../assets/images/social_activities_image.png";

import { fetchSocialActivities } from "../../services/apiService.js";

const SocialActivitiesPage = () => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      try {
        const response = await fetchSocialActivities();
        setData(response);
      } catch (error) {
        setError(error);
        console.error("Ошибка загрузки данных", error);
      } finally {
        setIsLoading(false);
      }
    };

    loadData();
  }, []);

  if (isLoading) {
    return (
      <div className="loader-wrapper">
        <Loader />
        <p className="loading-text">Загрузка...</p>
      </div>
    );
  }

  if (error) {
    return <ErrorPage />;
  }

  const socialActivity = Array.isArray(data) && data.length > 0 ? data[0] : null;

  const title = socialActivity?.title;
  const subtitle = socialActivity?.subtitle;
  const points = socialActivity?.points || [];

  return (
    <div className="social-activities-page">
      <Header />
      <nav className="page-nav">
        <a href="/" className="nav-link">
          Главная
        </a>
        <img src={ChevronRightIcon} alt="Chevron" className="nav-chevron-icon" />
        <a href="/about_company" className="nav-link">
          О компании
        </a>
        <img src={ChevronRightIcon} alt="Chevron" className="nav-chevron-icon" />
        <span className="nav-link">Социальная деятельность</span>
      </nav>

      <div className="social-activities-page-content">
        <h2 className="gradient-page-title">Социальная деятельность</h2>
        <img
          src={SocialActivitiesPageImage}
          alt="Social activities pic"
          className="social-activities-image"
        />
        <div className="social-activities-page-text-section">
          <h2 className="small-section-title">{title}</h2>
          <div className="social-responsibility-text-block">
            <p className="social-responsibility-text">{subtitle}</p>
            <ul className="social-responsibility-list">
              {points.map((point, index) => (
                <li key={index} className="social-responsibility-item">
                  {point}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default SocialActivitiesPage;